"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _get2 = _interopRequireDefault(require("lodash/get"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function VoucherDelete(row) {
  var targetEntity = (0, _get2["default"])(row, 'targetEntity');
  if (targetEntity) {
    return /*#__PURE__*/_react["default"].createElement("span", null, "Deleted voucher ", /*#__PURE__*/_react["default"].createElement("b", null, targetEntity));
  }
  return /*#__PURE__*/_react["default"].createElement("span", null, "Deleted unknown voucher");
}
var _default = exports["default"] = VoucherDelete;